import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Suspense } from "react";
import { AdminDashboardLayout } from "admin/ui";
import { adminAuthRoutes, adminRoutes } from "./app/utils";
import AuthGuard from "providers/auth-guard";
import NotExistPage from "common/base/404";

function AdminApp() {
  // const authHook = useAuth();
  return (
      <BrowserRouter>
        <Routes>
          <Route element={<AuthGuard {...{
            loginRoute: "adminLogin"
          }}>
            <AdminDashboardLayout {...{
              onLogout() {
                // authHook.logout(routeNames.adminLogin);
              },
            }}/>
          </AuthGuard>}>
            {adminRoutes.map((route, index) => {
              return (
                  <Route
                    path={route.path}
                    key={route.path + "---" + index}
                    element={<Suspense>
                      <route.Component/>
                      </Suspense>}
                  />
              );
            })}
          </Route>
          {adminAuthRoutes.map((route, index) => {
            return (
              
              <Route
                path={route.path}
                key={route.path + "---" + index}
                element={<Suspense>
                  <route.Component />
                  </Suspense>
                  }
              />
            );
          })}
          <Route path="*" element={<NotExistPage/>} />
        </Routes>
      </BrowserRouter>
    );
}

export default AdminApp;
